import '.eg{font-size:1.125rem;}.ssr-plugin'
import '.ee{line-height:1.75rem;}.ssr-plugin'
import '.ec{text-decoration:none;}.ssr-plugin'
import '.ga{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="eg ee"
    >
      {translations.privacySubtitle}{' '}
      <a className="ec ga"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="ec ga"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
